import React from "react";
import "../../App.css";
import PatientsPresentationAddStep1 from "../patients/patientsPresentationAdd/PatientsPresentationAddStep1";
import { Grid } from "@material-ui/core";
import { withSnackbar } from "../../components/atoms/SpSnackBar";

const PatientsPresentationAdd = (props) => {
  return (
    <Grid
      style={{ paddingLeft: "1%" }}
      direction="column"
      container
      spacing={2}
    >
      <Grid item xs={12} container spacing={1}>
        <Grid item xs={12}>
          <PatientsPresentationAddStep1 onSave={props.onSave} />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default withSnackbar(PatientsPresentationAdd);
